// extracted by mini-css-extract-plugin
export default {"form":"ProjectsConstructorForm_form__A43wY"};